import { RegisteredComponent } from "@builder.io/sdk-react";
import {
  DLD_FIELD,
  DLT_FIELD,
  LEGACY_HREF_FIELD,
  THEME_FIELD,
  TITLE_FIELD,
} from "../commonFields";

export const chromelessHeaderBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Chromeless Header",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  models: ["page-header"],
  inputs: [
    {
      name: "logo",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            name: "Image",
            options: {
              alt: "SolarWinds Logo",
              source: "aprimo",
              image:
                "https://p1.aprimocdn.net/solarwinds/9fb60ea3-97a1-4c13-9cee-b2420142a6d8/SW_Logo_Web_White_Original%20file.svg",
            },
          },
          responsiveStyles: {
            large: {
              boxSizing: "border-box",
              display: "flex",
              position: "relative",
              flexDirection: "column",
              flexShrink: "0",
              alignSelf: "center",
              marginTop: "0",
              width: "100%",
              maxWidth: "240px",
            },
          },
        },
      ],
    },
    {
      name: "link",
      type: "object",
      subFields: [
        { ...TITLE_FIELD, required: false },
        { ...LEGACY_HREF_FIELD, required: false },
        { ...DLT_FIELD, required: false },
        { ...DLD_FIELD, required: false },
      ],
      defaultValue: {
        title: {
          "@type": "@builder.io/core:LocalizedValue",
          Default: "SolarWinds",
        },
        href: {
          "@type": "@builder.io/core:LocalizedValue",
          Default: "https://www.solarwinds.com",
        },
        dlt: "Chromeless Header",
        dld: "SolarWinds Logo",
      },
    },
    {
      ...THEME_FIELD,
      defaultValue: "white",
      enum: [
        {
          label: "white",
          value: "white",
        },
        {
          label: "gray",
          value: "gray",
        },
        {
          label: "black",
          value: "black",
        },
        {
          label: "orange",
          value: "orange",
        },
        {
          label: "cool gray",
          value: "cool-gray",
        },
      ],
    },
    {
      name: "icon",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            name: "Icon",
            options: {
              source: "aprimo",
              icon: "https://p1.aprimocdn.net/solarwinds/8da24c2c-e8e6-4e3f-8fde-b3ae00ed9ebb/gidget_8_dots_Original%20file.svg",
              color: "var(--color-symbol-orange-400-graphic, #ff6200)",
              width: 64,
            },
          },
          responsiveStyles: {
            large: {
              boxSizing: "border-box",
              display: "flex",
              position: "relative",
              flexDirection: "column",
              flexShrink: "0",
              width: "100%",
            },
          },
        },
      ],
    },
  ],
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flexShrink: "0",
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "var(--color-background,#ffffff)",
  },
  canHaveChildren: false,
};
